
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/


(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:order:AllLoaded', function(event){
    Flits(".flits-order-count-badge").text(Flits.order.settings.orderSize);
  });
  Flits(document).on("click", ".flits-reorder-btn", function (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      let items = flitsOrder[Flits(this).attr("data-target")];
      let params = {};
      let noItem = 0;
      let soldOutItem = 0;
      params["items"] = [];
      if (items.length > 0) {
          for (let i = 0; items.length > i; i++) {
              let item = items[i];
              if (!item.item_variant_id) {
                  noItem++;
              } else {
                  if (item.available == "true") {
                      if (parseInt(item.inventory_quantity) <= parseInt(item.quantity)) {
                          if (cartOrder[item.variant_id]) {
                              if (parseInt(item.inventory_quantity) > parseInt(cartOrder[item.variant_id].cart_quantity)) {
                                  item.quantity = parseInt(item.inventory_quantity) - parseInt(cartOrder[item.variant_id].cart_quantity);
                              } else {
                                  item.quantity = parseInt(item.inventory_quantity);
                              }
                              flitsSnackbar.show({
                                  text: Flits.t("Flits.locals.general.cart_updated", "Some items are no longer available. Your cart has been updated."),
                                  pos: "bottom-center",
                                  showAction: false,
                                  customClass: "flits-alert-default",
                              });
                          }
                      } else {
                          if (cartOrder[item.variant_id]) {
                              if (parseInt(item.inventory_quantity) <= parseInt(cartOrder[item.variant_id].cart_quantity) + parseInt(item.quantity)) {
                                  item.quantity = parseInt(item.inventory_quantity) - parseInt(cartOrder[item.variant_id].cart_quantity);
                                  flitsSnackbar.show({
                                      text: Flits.t("Flits.locals.general.cart_updated", "Some items are no longer available. Your cart has been updated."),
                                      pos: "bottom-center",
                                      showAction: false,
                                      customClass: "flits-alert-default",
                                  });
                              }
                          }
                      }
                      params["items"].push({ id: item.variant_id, quantity: item.quantity, properties:item.properties });
                  } else {
                      soldOutItem++;
                  }
              }
          }
          if (noItem == 1) {
              flitsSnackbar.show({ text: Flits.t("Flits.locals.order_page.one_product_unavailable", "One of the products is unavailable"), pos: "bottom-center", showAction: false, customClass: "flits-alert-default" });
          } else if (noItem > 1) {
              flitsSnackbar.show({ text: Flits.t("Flits.locals.order_page.some_products_unavailable", "Some of the products are unavailable"), pos: "bottom-center", showAction: false, customClass: "flits-alert-default" });
          }
          if (soldOutItem == 1) {
              setTimeout(
                  function () {
                      flitsSnackbar.show({ text: Flits.t("Flits.locals.order_page.one_product_sold_out", "One of the products is sold out."), pos: "bottom-center", showAction: false, customClass: "flits-alert-default" });
                  },
                  noItem > 0 ? 1500 : 0
              );
          } else if (soldOutItem > 1) {
              setTimeout(
                  function () {
                      flitsSnackbar.show({ text: Flits.t("Flits.locals.order_page.some_products_sold_out", "Some of the products are sold out"), pos: "bottom-center", showAction: false, customClass: "flits-alert-default" });
                  },
                  noItem > 0 ? 1500 : 0
              );
          }
          Flits.dispatchEvent("Flits:order:BeforeReOrder", { params: params });
          setTimeout(
              function () {
                  Flits.addToCart(params);
              },
              soldOutItem > 0 || noItem > 0 ? 2500 : 1000
          );
      }
  });
}(Flits));
